import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="page-container stack">
      <h1>Seite nicht gefunden</h1>
      <p>Diese Seite existiert nicht oder ist nicht mehr verfügbar.</p>
      <Link to="/" className="button button--primary">
        Zur Startseite
      </Link>
    </div>
  );
}
